import { render, staticRenderFns } from "./AppointmentPartnerCategories.vue?vue&type=template&id=1916314e"
import script from "./AppointmentPartnerCategories.vue?vue&type=script&lang=ts"
export * from "./AppointmentPartnerCategories.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentPartnerCategories.vue?vue&type=style&index=0&id=1916314e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports